import { useState } from 'react';
import { Modal } from './modal.jsx';

/**
 * Confirmation dialog with destructive variant.
 *
 * Usage:
 *   <ConfirmDialog
 *     open={open}
 *     title="Delete user"
 *     message="This will permanently remove the operator."
 *     confirmLabel="Delete"
 *     destructive
 *     onConfirm={handleDelete}
 *     onClose={() => setOpen(false)}
 *   />
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
}) {
  const [busy, setBusy] = useState(false);

  async function handleConfirm() {
    setBusy(true);
    try {
      await onConfirm?.();
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={busy ? () => {} : onClose}
      title={title}
      size="sm"
      footer={
        <>
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={busy}
            data-skip-autofocus
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={busy}
            className={
              destructive
                ? 'btn bg-rose-600 text-white hover:bg-rose-700 disabled:bg-rose-400'
                : 'btn-primary'
            }
          >
            {busy ? (
              <>
                <span className="loader-spinner" aria-hidden="true" />
                Working…
              </>
            ) : (
              <>
                {destructive && (
                  <i className="fa-solid fa-trash" aria-hidden="true" />
                )}
                {confirmLabel}
              </>
            )}
          </button>
        </>
      }
    >
      <p className="text-sm leading-relaxed text-ink">{message}</p>
    </Modal>
  );
}
